// extracted by mini-css-extract-plugin
export default {"linkCard":"style-module--linkCard--D-dOQ","imgCard":"style-module--imgCard--DBHfU"};